import { FC, useRef } from 'react';

import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';

import { useAutoOpenTranscriptorRecording } from '@/features/transcriptorDeepLink';

import { PatientProfile } from './PatientProfile';
import { PatientProfile_DEPRECATED } from './PatientProfile_DEPRECATED';

// WARN: Temporary solution for using old and new patient profile pages during development
export const PatientProfilePageContainer: FC = () => {
  const organizationLoading = useAppSelector(
    organizationModel.selectors.selectLoading,
  );

  useAutoOpenTranscriptorRecording();

  const { isFDA } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  const showNewPatientPage = !isFDA;
  // Stream reconnects may temporarily move the global organization state back
  // to pending. Once the organization has loaded, keep the patient workspace
  // mounted so local editor and agent state are not discarded.
  const hasLoadedOrganizationRef = useRef(false);

  if (organizationLoading === 'succeeded') {
    hasLoadedOrganizationRef.current = true;
  }

  if (!hasLoadedOrganizationRef.current) {
    return null;
  }

  return showNewPatientPage ? (
    <PatientProfile />
  ) : (
    <PatientProfile_DEPRECATED />
  );
};
